// @ts-nocheck
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Capacitor } from '@capacitor/core';
import api from '../api'; // Use existing configured api instance

export type OAuthProvider = 'google' | 'apple' | 'facebook';

/**
 * Perform OAuth Login via Capacitor Firebase Authentication
 * Works seamlessly on iOS, Android, and Web.
 */
export const performOAuthLogin = async (provider: OAuthProvider) => {
    try {
        let result;
        if (provider === 'google') {
            result = await FirebaseAuthentication.signInWithGoogle();
        } else if (provider === 'apple') {
            result = await FirebaseAuthentication.signInWithApple();
        } else if (provider === 'facebook') {
            result = await FirebaseAuthentication.signInWithFacebook();
        } else {
            throw new Error(`Unsupported provider: ${provider}`);
        }

        const idToken = result.credential?.idToken;
        if (!idToken) {
            throw new Error('Failed to retrieve ID Token from Firebase');
        }

        return {
            idToken,
            provider,
            firebaseUser: result.user
        };
    } catch (error) {
        console.error(`[OAuth] Firebase ${provider} sign-in failed:`, error);
        throw error;
    }
};

/**
 * Send the ID token to our backend for verification and account linking/creation.
 */
export const verifyOAuthWithBackend = async (idToken: string, provider: OAuthProvider) => {
    const response = await api.post('auth/oauth', { idToken, provider });
    return response.data;
};

/**
 * Finalize an OAuth signup by providing the chosen username.
 */
export const finalizeOAuthSignup = async (idToken: string, username: string, provider: OAuthProvider) => {
    const response = await api.post('auth/oauth-signup', { idToken, username, provider });
    return response.data;
};
